module.exports = __webpack_public_path__ + "img/pollo_b11.3dd5c413.png";